/*
  beta环境配置
*/
export default  { // http://wedof-itsm.beta.autoai.com
    ssoServiceUser: 'https://itsmops-beta.autoai.com/usercenter/sso/operator/www/v1/', // 用户登录
    ssoService: 'https://wedof-beta.autoai.com/', // 用户验证码和key
    baseURL:"https://itsmops-beta.autoai.com/itsm/v1/",      // 业务接口
    roleUrl:"https://wedof-auth-beta.autoai.com/", // 新权限
    BASEURL:"https://itsmops-beta.autoai.com/",         //CICD关联
    BASE_API: 'https://itsmops-beta.autoai.com/',       // 上传
    sseurl:"https://itsmops-beta.autoai.com/itsm/stream",
    // sseurl:"https://itsmops-beta.autoai.com/stream",
    AuthUrl:"https://wedof-auth-beta.autoai.com/authority/v1/",
    manageUrl: 'https://wedof-auth-beta.autoai.com/authority/',
    filterUser:'https://wedof.autoai.com/',//搜索人员接口域名
    timeout: 30000,
    withCredentials: true,
    pageTitle: 'vue管理系统后台模版',
};
